var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',[(!_vm.ready)?_c('hm-spinner'):_vm._e(),_c('hm-alert'),(_vm.component)?_c(_vm.component,{tag:"component",attrs:{"data":_vm.data}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }